import { DEX_TYPE } from '@/config/constants'

function resolveDex(host) {
  if (host.includes('sgbuildex')) return DEX_TYPE.SGBUILDEX
  if (host.includes('sghealthdex')) return DEX_TYPE.SGHEALTHDEX
  if (host.includes('sgtradex')) return DEX_TYPE.SGTRADEX
  return null
}

export function getEnvAndDex() {
  const host = window.location.hostname
  let dex

  if (host === 'localhost') {
    dex = import.meta.env.VITE_DEX_TYPE
  } else {
    dex = resolveDex(host)
  }

  return { dex: dex || DEX_TYPE.SGBUILDEX }
}
